import React from "react";
import { IoClose } from "react-icons/io5";

const CustomPopup = ({ open, title, message, type = "info", onClose }) => {
  if (!open) return null;

  const colors = {
    success: "bg-green-50 text-green-700 border-green-200",
    error: "bg-red-50 text-red-700 border-red-200",
    info: "bg-blue-50 text-blue-700 border-blue-200",
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      
      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      {/* POPUP CARD */}
      <div className={`relative bg-white rounded-xl shadow-xl w-full max-w-sm p-5 border ${colors[type]}`}>
        
        {/* HEADER */}
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-base font-semibold">{title}</h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full">
            <IoClose className="h-5 w-5" />
          </button>
        </div>

        {/* MESSAGE */}
        <div className="text-sm mb-4">{message}</div>

        {/* BUTTON */}
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700"
          >
            OK
          </button>
        </div>

      </div>
    </div>
  );
};

export default CustomPopup;
